module.exports = __webpack_public_path__ + "img/visa.c.528dca68.png";